import React from 'react';

import {
  FormControl,
  InputLabel,
  MenuItem,
  Typography,
} from '@material-ui/core';

// Components
import Select from '../Mui/Select';

const Dropdown: React.FC<{
  name: string;
  label: string;
  value: string;
  required?: boolean;
  list: Array<{ [key: string]: any }>;
  listName: string;
  onChange: (name: string, value: string) => void;
  disabled: boolean;
  error?: boolean;
  loading: boolean;
  defaultLabel?: string;
  defaultValue?: string;
  startAdornment?: React.ReactNode;
  minWidth?: number | string;
}> = React.memo(
  ({
    name,
    label,
    value,
    required = false,
    list = [],
    listName,
    onChange,
    disabled,
    error,
    loading,
    defaultLabel = '',
    defaultValue = '',
    startAdornment = <></>,
    minWidth = 200,
  }) => (
    <FormControl
      required={required}
      fullWidth
      disabled={disabled}
      variant="outlined"
      className="m-r-16"
      style={{ minWidth }}
      error={error}
      data-testid={`filter-modal-select-${name}`}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        id={`filter-modal-select-${label}`}
        name={name}
        label={label ? `${label} ${required ? '*' : ''}` : undefined}
        value={value}
        renderValue={(value) => {
          return (
            <Typography
              style={{
                display: 'flex',
                alignItems: 'center',
                lineHeight: '1.25',
              }}
            >
              <Typography component="span" className="m-r-4">
                {startAdornment}
              </Typography>
              {list.find((item) => item[name] === value)?.[listName] ||
                defaultLabel ||
                ''}
            </Typography>
          );
        }}
        loading={loading}
        onChange={(
          event: React.ChangeEvent<{ name?: string; value: unknown }>,
        ) =>
          onChange(event.target.name as string, event.target.value as string)
        }
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {defaultLabel && (
          <MenuItem
            key={0}
            value={defaultValue}
            data-testid="filter-default-select-item"
          >
            {defaultLabel}
          </MenuItem>
        )}
        {list?.map((item, index) => (
          <MenuItem
            key={item[name]}
            value={item[name]}
            data-testid={`filter-${label.toLowerCase()}-select-item-${index}`}
          >
            {item[listName]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ),
);

export default Dropdown;
